// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --text-dark: #1f2937;
  --text-light: #6b7280;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.client-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.client-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  padding: 2rem;
  width: 100%;
}

.client-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 1.5rem;
  margin-bottom: 2rem;
}
.client-header .client-header-data {
  display: flex;
  justify-content: center;
  align-items: start;
}
.client-header .client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-header .client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-header .client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
}
.client-header .client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-header .client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
}
.client-header .client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-header .avatar {
  background-color: var(--primary-color);
  color: white;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
  font-weight: bold;
}
.client-header .client-title h2 {
  margin: 0;
  font-size: 1.3rem;
  color: var(--text-dark);
}
.client-header .client-title .company {
  font-size: 1rem;
  color: var(--text-light);
  margin-top: 0.5rem;
}

.client-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 0.8rem;
}
.client-details-grid .view-client-detail-item {
  display: flex;
  gap: 0.75rem;
}
.client-details-grid .view-client-detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 2px;
}
.client-details-grid .view-client-detail-item label {
  font-size: 0.75rem;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 0rem;
}
.client-details-grid .view-client-detail-item p {
  font-size: 0.95rem;
  color: var(--text-dark);
  margin: 0;
  font-weight: 500;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(79, 70, 229, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

.loading-message {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .client-detail-container {
    padding: 1rem;
  }
  .client-card {
    padding: 1.5rem;
  }
  .client-details-grid {
    grid-template-columns: 1fr;
  }
}
.client-cases {
  margin-top: 2rem;
}
.client-cases .caseids {
  cursor: pointer;
}
.client-cases h3 {
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}
.client-cases ul {
  padding-left: 1rem;
  list-style-type: disc;
}
.client-cases ul li {
  color: var(--text-dark);
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.client-invoices {
  margin-top: 2rem;
}
.client-invoices .invoice-header-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.client-invoices .invoice-header-section h3 {
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-dark);
  margin: 0;
}
.client-invoices .invoice-header-section .toggle-invoices-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.client-invoices .invoice-header-section .toggle-invoices-btn svg {
  font-size: 1.1rem;
}
.client-invoices .loading-message, .client-invoices .no-invoices {
  text-align: center;
  padding: 2rem;
  color: var(--text-light);
  font-size: 0.95rem;
}
.client-invoices .invoice-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}
.client-invoices .invoice-summary .summary-item {
  background: #f9fafb;
  padding: 0.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.client-invoices .invoice-summary .summary-item.success .summary-icon {
  color: var(--success-color);
}
.client-invoices .invoice-summary .summary-item.warning .summary-icon {
  color: var(--warning-color);
}
.client-invoices .invoice-summary .summary-item.pending .summary-icon {
  color: #3b82f6;
}
.client-invoices .invoice-summary .summary-item.cancelled .summary-icon {
  color: #ef4444;
}
.client-invoices .invoice-summary .summary-item .summary-icon {
  font-size: 1.75rem;
  color: var(--primary-color);
}
.client-invoices .invoice-summary .summary-item label {
  display: block;
  font-size: 0.75rem;
  color: var(--text-light);
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.client-invoices .invoice-summary .summary-item .summary-value {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
  margin: 0;
}
.client-invoices .invoice-summary .summary-item .count {
  font-size: 0.75rem;
  color: var(--text-light);
}
.client-invoices .invoice-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
}
.client-invoices .invoice-filter-bar .filter-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  background: white;
  color: var(--text-dark);
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.client-invoices .invoice-filter-bar .filter-btn svg {
  font-size: 1rem;
}
.client-invoices .invoice-filter-bar .filter-btn:hover {
  background: #f3f4f6;
  border-color: var(--primary-color);
}
.client-invoices .invoice-filter-bar .filter-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}
.client-invoices .invoice-filter-bar .filter-btn.paid.active {
  background: var(--success-color);
  border-color: var(--success-color);
}
.client-invoices .invoice-filter-bar .filter-btn.part-payment.active {
  background: var(--warning-color);
  border-color: var(--warning-color);
}
.client-invoices .invoice-filter-bar .filter-btn.pending.active {
  background: var(--primary-light-color);
  border-color: var(--primary-light-color);
}
.client-invoices .invoice-filter-bar .filter-btn.cancelled.active {
  background: var(--danger-color);
  border-color: var(--danger-color);
}
.client-invoices .invoice-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.client-invoices .invoice-list .invoice-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  transition: box-shadow 0.2s;
}
.client-invoices .invoice-list .invoice-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.client-invoices .invoice-list .invoice-card .invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-number {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  color: var(--text-dark);
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-number svg {
  font-size: 1.25rem;
  color: var(--primary-color);
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status svg {
  font-size: 1rem;
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-paid {
  background: #d1fae5;
  color: var(--success-color);
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-pending {
  background: #dbeafe;
  color: var(--primary-light-color);
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-part-payment {
  background: #fef3c7;
  color: var(--warning-color);
}
.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-cancelled {
  background: #fee2e2;
  color: var(--danger-color);
}
.client-invoices .invoice-list .invoice-card .invoice-body {
  padding: 1.25rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details {
  margin-bottom: 1rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details .detail-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0;
  color: var(--text-dark);
  font-size: 0.9rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details .detail-row svg {
  color: var(--primary-color);
  font-size: 1.1rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details .detail-row:first-child {
  font-weight: 500;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items h4 {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header {
  display: grid;
  grid-template-columns: 2fr 0.8fr 1fr 1fr;
  gap: 1rem;
  background: #f9fafb;
  padding: 0.875rem 1rem;
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--text-dark);
  border-bottom: 2px solid #e5e7eb;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-item {
  text-align: left;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-qty,
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-rate,
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-amount {
  text-align: right;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row {
  display: grid;
  grid-template-columns: 2fr 0.8fr 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.15s;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row:hover {
  background-color: #f1f1f1;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row:last-child {
  border-bottom: none;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-item .item-name {
  font-weight: 600;
  color: var(--text-dark);
  font-size: 0.95rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-item .item-description {
  font-size: 0.8rem;
  color: var(--text-light);
  line-height: 1.4;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-qty,
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-rate,
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-amount {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.9rem;
  color: var(--text-dark);
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-qty {
  font-weight: 500;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-amount {
  font-weight: 700;
  color: var(--primary-color);
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments h4 {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item {
  background: #f0fdf4;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  border-left: 3px solid #10b981;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details .payment-icon {
  color: #10b981;
  font-size: 1.1rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details .payment-type {
  font-weight: 600;
  color: var(--text-dark);
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details .payment-amount {
  font-weight: 700;
  color: #10b981;
  margin-left: auto;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-meta {
  display: flex;
  gap: 1rem;
  font-size: 0.8rem;
  color: var(--text-light);
  padding-left: 1.6rem;
}
.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-meta span:not(:last-child)::after {
  content: "•";
  margin-left: 1rem;
}

@media (max-width: 768px) {
  .client-invoices .invoice-header-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .client-invoices .invoice-header-section .toggle-invoices-btn {
    width: 100%;
    justify-content: center;
  }
  .client-invoices .invoice-summary {
    grid-template-columns: 1fr;
  }
  .client-invoices .invoice-filter-bar .filter-btn {
    flex: 1 1 auto;
    min-width: 120px;
    justify-content: center;
  }
  .client-invoices .invoice-card .invoice-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  .client-invoices .invoice-card .payment-meta {
    flex-direction: column;
    gap: 0.25rem !important;
  }
  .client-invoices .invoice-card .payment-meta span::after {
    display: none !important;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-header {
    display: none;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 0.875rem;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-item {
    order: 1;
    padding-bottom: 0.5rem;
    border-bottom: 1px dashed #e5e7eb;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty,
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate,
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount {
    justify-content: space-between;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty::before,
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate::before,
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount::before {
    font-weight: 600;
    color: var(--text-light);
    font-size: 0.8rem;
    text-transform: uppercase;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty {
    order: 2;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty::before {
    content: "Quantity:";
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate {
    order: 3;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate::before {
    content: "Rate:";
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount {
    order: 4;
    padding-top: 0.5rem;
    border-top: 1px solid #e5e7eb;
  }
  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount::before {
    content: "Amount:";
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewMyClient/ViewMyClient.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4CAAA;AAEF;;AACA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AAEF;;AACA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,aAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,mBAAA;AAEF;AAAE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAEJ;AACE;EACA,aAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AACJ;AACI;EACE,yCAAA;EACA,2BAAA;AACN;AACM;EACE,YAAA;EACA,2BAAA;AACR;AAGI;EACE,wCAAA;EACA,0BAAA;AADN;AAGM;EACE,YAAA;EACA,2BAAA;AADR;AAOE;EACE,sCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AALJ;AASI;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;AAPN;AAUI;EACE,eAAA;EACA,wBAAA;EACA,kBAAA;AARN;;AAaA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;AAVF;AAYE;EACE,aAAA;EACA,YAAA;AAVJ;AAYI;EACE,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAVN;AAaI;EACE,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AAXN;AAcI;EACE,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAZN;;AAqCA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;AAlCF;;AAqCA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAlCF;;AAoCA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;AAjCF;;AAoCA;EACE;IACE,yBAAA;EAjCF;AACF;AAoCA;EACE;IACE,aAAA;EAlCF;EAqCA;IACE,eAAA;EAnCF;EAsCA;IACE,0BAAA;EApCF;AACF;AAsCA;EACE,gBAAA;AApCF;AAqCE;EACE,eAAA;AAnCJ;AAsCE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;AApCJ;AAuCE;EACE,kBAAA;EACA,qBAAA;AArCJ;AAuCI;EACE,uBAAA;EACA,kBAAA;EACA,sBAAA;AArCN;;AA2CA;EACE,gBAAA;AAxCF;AA2CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AAzCJ;AA2CI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;AAzCN;AA4CI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,yCAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA1CN;AA4CM;EACE,iBAAA;AA1CR;AA+CE;EACE,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;AA7CJ;AAgDE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA9CJ;AAgDI;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA9CN;AAkDQ;EACE,2BAAA;AAhDV;AAsDQ;EACE,2BAAA;AApDV;AA0DQ;EACE,cAAA;AAxDV;AA8DQ;EACE,cAAA;AA5DV;AAgEM;EACE,kBAAA;EACA,2BAAA;AA9DR;AAiEM;EACE,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AA/DR;AAkEM;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAhER;AAmEM;EACE,kBAAA;EACA,wBAAA;AAjER;AAsEE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AApEJ;AAsEI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AApEN;AAsEM;EACE,eAAA;AApER;AAuEM;EACE,mBAAA;EACA,kCAAA;AArER;AAwEM;EACE,gCAAA;EACA,YAAA;EACA,kCAAA;AAtER;AAyEM;EACE,gCAAA;EACA,kCAAA;AAvER;AA0EM;EACE,gCAAA;EACA,kCAAA;AAxER;AA2EM;EACE,sCAAA;EACA,wCAAA;AAzER;AA4EM;EACE,+BAAA;EACA,iCAAA;AA1ER;AA+EE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7EJ;AA+EI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AA7EN;AA+EM;EACE,0CAAA;AA7ER;AAgFM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;AA9ER;AAgFQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AA9EV;AAgFU;EACE,kBAAA;EACA,2BAAA;AA9EZ;AAkFQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAhFV;AAkFU;EACE,eAAA;AAhFZ;AAmFU;EACE,mBAAA;EACA,2BAAA;AAjFZ;AAoFU;EACE,mBAAA;EACA,iCAAA;AAlFZ;AAqFU;EACE,mBAAA;EACA,2BAAA;AAnFZ;AAsFU;EACE,mBAAA;EACA,0BAAA;AApFZ;AAyFM;EACE,gBAAA;AAvFR;AAyFQ;EACE,mBAAA;AAvFV;AAyFU;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAvFZ;AAyFY;EACE,2BAAA;EACA,iBAAA;AAvFd;AA0FY;EACE,gBAAA;AAxFd;AA6FQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA3FV;AA6FU;EACE,iBAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AA3FZ;AA8FU;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA5FZ;AA8FY;EACE,aAAA;EACA,wCAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;AA5Fd;AA8Fc;EACE,gBAAA;AA5FhB;AA+Fc;;;EAGE,iBAAA;AA7FhB;AAkGc;EACE,aAAA;EACA,wCAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;EACA,kCAAA;AAhGhB;AAkGgB;EACE,yBAAA;AAhGlB;AAmGgB;EACE,mBAAA;AAjGlB;AAoGgB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlGlB;AAoGkB;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;AAlGpB;AAqGkB;EACE,iBAAA;EACA,wBAAA;EACA,gBAAA;AAnGpB;AAuGgB;;;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,uBAAA;AArGlB;AAwGgB;EACE,gBAAA;AAtGlB;AAyGgB;EACE,gBAAA;EACA,2BAAA;AAvGlB;AA8GQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA5GV;AA8GU;EACE,iBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AA5GZ;AA+GU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;AA7GZ;AA+GY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA7Gd;AA+Gc;EACE,cAAA;EACA,iBAAA;AA7GhB;AAgHc;EACE,gBAAA;EACA,uBAAA;AA9GhB;AAiHc;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AA/GhB;AAmHY;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,wBAAA;EACA,oBAAA;AAjHd;AAoHgB;EACE,YAAA;EACA,iBAAA;AAlHlB;;AA8HA;EAEI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EA5HJ;EA8HI;IACE,WAAA;IACA,uBAAA;EA5HN;EAgIE;IACE,0BAAA;EA9HJ;EAkII;IACE,cAAA;IACA,gBAAA;IACA,uBAAA;EAhIN;EAqII;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;EAnIN;EAsII;IACE,sBAAA;IACA,uBAAA;EApIN;EAsIM;IACE,wBAAA;EApIR;EA0IQ;IACE,aAAA;EAxIV;EA4IU;IACE,0BAAA;IACA,WAAA;IACA,iBAAA;EA1IZ;EA4IY;IACE,QAAA;IACA,sBAAA;IACA,iCAAA;EA1Id;EA6IY;;;IAGE,8BAAA;EA3Id;EA6Ic;;;IACE,gBAAA;IACA,wBAAA;IACA,iBAAA;IACA,yBAAA;EAzIhB;EA6IY;IACE,QAAA;EA3Id;EA4Ic;IACE,oBAAA;EA1IhB;EA8IY;IACE,QAAA;EA5Id;EA6Ic;IACE,gBAAA;EA3IhB;EA+IY;IACE,QAAA;IACA,mBAAA;IACA,6BAAA;EA7Id;EA8Ic;IACE,kBAAA;EA5IhB;AACF","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --text-dark: #1f2937;\n  --text-light: #6b7280;\n  --success-color: #10b981;\n  --danger-color: #ef4444;\n  --border-radius: 12px;\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n.client-detail-container {\n  padding: 1rem;\n  background-color: #f4f6f8;\n  display: flex;\n}\n\n.client-card {\n  background-color: var(--card-bg);\n  border-radius: var(--border-radius-primary);\n  box-shadow: var(--box-shadow);\n  padding: 2rem;\n  width: 100%;\n}\n\n.client-header {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 1.5rem;\n  margin-bottom: 2rem;\n}\n.client-header .client-header-data {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n}\n.client-header .client-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n.client-header .client-actions button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n.client-header .client-actions button.btn-update {\n  background-color: var(--primary-light-bg);\n  color: var(--primary-color);\n}\n.client-header .client-actions button.btn-update:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n.client-header .client-actions button.btn-delete {\n  background-color: var(--danger-light-bg);\n  color: var(--danger-color);\n}\n.client-header .client-actions button.btn-delete:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n.client-header .avatar {\n  background-color: var(--primary-color);\n  color: white;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  font-size: 1.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1.5rem;\n  font-weight: bold;\n}\n.client-header .client-title h2 {\n  margin: 0;\n  font-size: 1.3rem;\n  color: var(--text-dark);\n}\n.client-header .client-title .company {\n  font-size: 1rem;\n  color: var(--text-light);\n  margin-top: 0.5rem;\n}\n\n.client-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 0.8rem;\n}\n.client-details-grid .view-client-detail-item {\n  display: flex;\n  gap: 0.75rem;\n}\n.client-details-grid .view-client-detail-item .icon {\n  color: var(--primary-color);\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.client-details-grid .view-client-detail-item label {\n  font-size: 0.75rem;\n  color: var(--text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: block;\n  margin-bottom: 0rem;\n}\n.client-details-grid .view-client-detail-item p {\n  font-size: 0.95rem;\n  color: var(--text-dark);\n  margin: 0;\n  font-weight: 500;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(79, 70, 229, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.error-message {\n  color: var(--danger-color);\n  font-size: 1rem;\n  padding: 2rem;\n  text-align: center;\n}\n\n.loading-message {\n  text-align: center;\n  font-size: 1.1rem;\n  color: var(--text-color-medium);\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (max-width: 768px) {\n  .client-detail-container {\n    padding: 1rem;\n  }\n  .client-card {\n    padding: 1.5rem;\n  }\n  .client-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.client-cases {\n  margin-top: 2rem;\n}\n.client-cases .caseids {\n  cursor: pointer;\n}\n.client-cases h3 {\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-dark);\n  margin-bottom: 0.5rem;\n}\n.client-cases ul {\n  padding-left: 1rem;\n  list-style-type: disc;\n}\n.client-cases ul li {\n  color: var(--text-dark);\n  font-size: 0.95rem;\n  margin-bottom: 0.25rem;\n}\n\n.client-invoices {\n  margin-top: 2rem;\n}\n.client-invoices .invoice-header-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n.client-invoices .invoice-header-section h3 {\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-dark);\n  margin: 0;\n}\n.client-invoices .invoice-header-section .toggle-invoices-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: var(--primary-light-bg);\n  color: var(--primary-color);\n  border: none;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.client-invoices .invoice-header-section .toggle-invoices-btn svg {\n  font-size: 1.1rem;\n}\n.client-invoices .loading-message, .client-invoices .no-invoices {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-light);\n  font-size: 0.95rem;\n}\n.client-invoices .invoice-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n.client-invoices .invoice-summary .summary-item {\n  background: #f9fafb;\n  padding: 0.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.client-invoices .invoice-summary .summary-item.success .summary-icon {\n  color: var(--success-color);\n}\n.client-invoices .invoice-summary .summary-item.warning .summary-icon {\n  color: var(--warning-color);\n}\n.client-invoices .invoice-summary .summary-item.pending .summary-icon {\n  color: #3b82f6;\n}\n.client-invoices .invoice-summary .summary-item.cancelled .summary-icon {\n  color: #ef4444;\n}\n.client-invoices .invoice-summary .summary-item .summary-icon {\n  font-size: 1.75rem;\n  color: var(--primary-color);\n}\n.client-invoices .invoice-summary .summary-item label {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-light);\n  margin-bottom: 0.25rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.client-invoices .invoice-summary .summary-item .summary-value {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--text-dark);\n  margin: 0;\n}\n.client-invoices .invoice-summary .summary-item .count {\n  font-size: 0.75rem;\n  color: var(--text-light);\n}\n.client-invoices .invoice-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n.client-invoices .invoice-filter-bar .filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.5rem 1rem;\n  background: white;\n  color: var(--text-dark);\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.client-invoices .invoice-filter-bar .filter-btn svg {\n  font-size: 1rem;\n}\n.client-invoices .invoice-filter-bar .filter-btn:hover {\n  background: #f3f4f6;\n  border-color: var(--primary-color);\n}\n.client-invoices .invoice-filter-bar .filter-btn.active {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n.client-invoices .invoice-filter-bar .filter-btn.paid.active {\n  background: var(--success-color);\n  border-color: var(--success-color);\n}\n.client-invoices .invoice-filter-bar .filter-btn.part-payment.active {\n  background: var(--warning-color);\n  border-color: var(--warning-color);\n}\n.client-invoices .invoice-filter-bar .filter-btn.pending.active {\n  background: var(--primary-light-color);\n  border-color: var(--primary-light-color);\n}\n.client-invoices .invoice-filter-bar .filter-btn.cancelled.active {\n  background: var(--danger-color);\n  border-color: var(--danger-color);\n}\n.client-invoices .invoice-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.client-invoices .invoice-list .invoice-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: box-shadow 0.2s;\n}\n.client-invoices .invoice-list .invoice-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.client-invoices .invoice-list .invoice-card .invoice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-number {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--text-dark);\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-number svg {\n  font-size: 1.25rem;\n  color: var(--primary-color);\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem 0.875rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status svg {\n  font-size: 1rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-paid {\n  background: #d1fae5;\n  color: var(--success-color);\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-pending {\n  background: #dbeafe;\n  color: var(--primary-light-color);\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-part-payment {\n  background: #fef3c7;\n  color: var(--warning-color);\n}\n.client-invoices .invoice-list .invoice-card .invoice-header .invoice-status.status-cancelled {\n  background: #fee2e2;\n  color: var(--danger-color);\n}\n.client-invoices .invoice-list .invoice-card .invoice-body {\n  padding: 1.25rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details {\n  margin-bottom: 1rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details .detail-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem 0;\n  color: var(--text-dark);\n  font-size: 0.9rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details .detail-row svg {\n  color: var(--primary-color);\n  font-size: 1.1rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-details .detail-row:first-child {\n  font-weight: 500;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items h4 {\n  font-size: 0.9rem;\n  color: var(--text-light);\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header {\n  display: grid;\n  grid-template-columns: 2fr 0.8fr 1fr 1fr;\n  gap: 1rem;\n  background: #f9fafb;\n  padding: 0.875rem 1rem;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--text-dark);\n  border-bottom: 2px solid #e5e7eb;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-item {\n  text-align: left;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-qty,\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-rate,\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-header .col-amount {\n  text-align: right;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row {\n  display: grid;\n  grid-template-columns: 2fr 0.8fr 1fr 1fr;\n  gap: 1rem;\n  padding: 1rem;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.15s;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row:hover {\n  background-color: #f1f1f1;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row:last-child {\n  border-bottom: none;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-item .item-name {\n  font-weight: 600;\n  color: var(--text-dark);\n  font-size: 0.95rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-item .item-description {\n  font-size: 0.8rem;\n  color: var(--text-light);\n  line-height: 1.4;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-qty,\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-rate,\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-amount {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-size: 0.9rem;\n  color: var(--text-dark);\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-qty {\n  font-weight: 500;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-items .items-table .items-table-body .items-table-row .col-amount {\n  font-weight: 700;\n  color: var(--primary-color);\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments h4 {\n  font-size: 0.9rem;\n  color: var(--text-light);\n  margin-bottom: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item {\n  background: #f0fdf4;\n  padding: 0.75rem;\n  border-radius: 6px;\n  margin-bottom: 0.5rem;\n  border-left: 3px solid #10b981;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details .payment-icon {\n  color: #10b981;\n  font-size: 1.1rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details .payment-type {\n  font-weight: 600;\n  color: var(--text-dark);\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-details .payment-amount {\n  font-weight: 700;\n  color: #10b981;\n  margin-left: auto;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-meta {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.8rem;\n  color: var(--text-light);\n  padding-left: 1.6rem;\n}\n.client-invoices .invoice-list .invoice-card .invoice-body .invoice-payments .payment-item .payment-meta span:not(:last-child)::after {\n  content: \"•\";\n  margin-left: 1rem;\n}\n\n@media (max-width: 768px) {\n  .client-invoices .invoice-header-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  .client-invoices .invoice-header-section .toggle-invoices-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  .client-invoices .invoice-summary {\n    grid-template-columns: 1fr;\n  }\n  .client-invoices .invoice-filter-bar .filter-btn {\n    flex: 1 1 auto;\n    min-width: 120px;\n    justify-content: center;\n  }\n  .client-invoices .invoice-card .invoice-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n  .client-invoices .invoice-card .payment-meta {\n    flex-direction: column;\n    gap: 0.25rem !important;\n  }\n  .client-invoices .invoice-card .payment-meta span::after {\n    display: none !important;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-header {\n    display: none;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    padding: 0.875rem;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-item {\n    order: 1;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px dashed #e5e7eb;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty,\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate,\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount {\n    justify-content: space-between;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty::before,\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate::before,\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount::before {\n    font-weight: 600;\n    color: var(--text-light);\n    font-size: 0.8rem;\n    text-transform: uppercase;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty {\n    order: 2;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-qty::before {\n    content: \"Quantity:\";\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate {\n    order: 3;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-rate::before {\n    content: \"Rate:\";\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount {\n    order: 4;\n    padding-top: 0.5rem;\n    border-top: 1px solid #e5e7eb;\n  }\n  .client-invoices .invoice-card .invoice-items .items-table .items-table-body .items-table-row .col-amount::before {\n    content: \"Amount:\";\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
